const getBreakpointValueDifference = (initialValue = {}, currentValue = {}) => {
  const breakpointKeys = new Set([...Object.keys(initialValue), ...Object.keys(currentValue)]);

  return Array.from(breakpointKeys).reduce((difference, breakpointKey) => {
    if (initialValue[breakpointKey] === currentValue[breakpointKey]) {
      return difference;
    }

    return {
      ...difference,
      [breakpointKey]: currentValue[breakpointKey],
    };
  }, {});
};

const getTargetsDifferencePerBreakpoint = (initialTargets = {}, currentTargets = {}) => {
  const targetKeys = new Set([...Object.keys(initialTargets), ...Object.keys(currentTargets)]);

  return Array.from(targetKeys).reduce((diff, targetKey) => {
    const initialValue = initialTargets[targetKey] || {};
    const currentValue = currentTargets[targetKey] || {};
    const breakpointDifference = getBreakpointValueDifference(initialValue, currentValue);

    if (Object.keys(breakpointDifference).length > 0) {
      return { ...diff, [targetKey]: breakpointDifference };
    }

    return diff;
  }, {});
};

const getStateDifferencePerBreakpoint = (initialState = {}, currentState = {}) => {
  const elementIds = new Set([...Object.keys(initialState), ...Object.keys(currentState)]);

  return Array.from(elementIds).reduce((diff, elementId) => {
    const initialTargets = initialState[elementId] || {};
    const currentTargets = currentState[elementId] || {};
    const targetsDiff = getTargetsDifferencePerBreakpoint(initialTargets, currentTargets);

    if (Object.keys(targetsDiff).length > 0) {
      return { ...diff, [elementId]: targetsDiff };
    }

    return diff;
  }, {});
};

export default getStateDifferencePerBreakpoint;
